module.exports = __webpack_public_path__ + "img/1.121cdcf2.png";